import posthog from "posthog-js"

let analyticsAllowed = false
let initialized = false
let lastPageviewUrl: string | undefined

export function capturePageview() {
  if (
    typeof window === "undefined" ||
    !analyticsAllowed ||
    !initialized ||
    !posthog.has_opted_in_capturing()
  ) {
    return
  }

  const url = window.location.href
  // Consent restoration and Gatsby's initial route update can both run.
  if (url === lastPageviewUrl) return
  posthog.capture("$pageview", { $current_url: url })
  lastPageviewUrl = url
}

export function setAnalyticsConsent(allowed: boolean) {
  analyticsAllowed = allowed
  if (typeof window === "undefined") return

  if (!allowed) {
    lastPageviewUrl = undefined
    if (initialized) posthog.opt_out_capturing()
    return
  }

  // The banner is authoritative, even if an old PostHog opt-in is still stored.
  // Waiting for consent also avoids creating analytics storage or requests early.
  if (!initialized) {
    const apiKey = process.env.GATSBY_POSTHOG_API_KEY
    if (!apiKey) return
    posthog.init(apiKey, {
      api_host: process.env.GATSBY_POSTHOG_HOST,
      opt_out_capturing_by_default: true,
      opt_out_persistence_by_default: true,
      capture_pageview: false,
    })
    initialized = true
  }

  if (!posthog.has_opted_in_capturing()) posthog.opt_in_capturing()
  capturePageview()
}
